import { useState } from 'react';

const FORMULAS = [
  {
    title: 'Máy tính rủi ro',
    icon: 'ri-crosshair-line',
    formula: 'Lot = (Số dư × Tỷ lệ rủi ro%) ÷ (Stop Loss × Giá trị Pip)',
    desc: 'Xác định khối lượng lệnh sao cho khoản thua lỗ tối đa nếu chạm Stop Loss không vượt quá tỷ lệ rủi ro bạn chấp nhận trên số dư tài khoản.',
    symbols: [
      { sym: 'Số dư', meaning: 'Số dư tài khoản' },
      { sym: 'Tỷ lệ rủi ro%', meaning: '% rủi ro mỗi lệnh' },
      { sym: 'Stop Loss', meaning: 'Khoảng cách cắt lỗ (pip)' },
      { sym: 'Giá trị Pip', meaning: 'Giá trị tiền của 1 pip' },
    ],
  },
  {
    title: 'Máy tính Drawdown',
    icon: 'ri-arrow-down-line',
    formula: 'Drawdown% = 1 − (1 − Lỗ%/lệnh)^n',
    desc: 'Với n là số lệnh thua liên tiếp. Công thức này cho biết mức sụt giảm của vốn nếu gặp một chuỗi thua lỗ liên tục.',
    symbols: [
      { sym: 'Lỗ%/lệnh', meaning: '% thua lỗ mỗi lệnh' },
      { sym: 'n', meaning: 'Số lệnh thua liên tiếp' },
    ],
  },
  {
    title: 'Rủi ro phá sản',
    icon: 'ri-alert-line',
    formula: 'ROR = ((1 − Edge) ÷ (1 + Edge))^(100 ÷ Rủi ro%)',
    desc: 'Với Edge = Tỷ lệ thắng × Lời/Lỗ − (1 − Tỷ lệ thắng), và 100 ÷ Rủi ro% chính là số đơn vị rủi ro của tài khoản. Ước tính xác suất tài khoản về 0 trong dài hạn; Edge càng dương và rủi ro mỗi lệnh càng thấp thì xác suất phá sản càng nhỏ.',
    symbols: [
      { sym: 'ROR', meaning: 'Risk of Ruin — rủi ro phá sản' },
      { sym: 'Edge', meaning: 'Lợi thế của chiến lược' },
      { sym: 'Rủi ro%', meaning: '% rủi ro mỗi lệnh' },
    ],
  },
];

export default function FormulaSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-violet-50 px-3 py-1 text-xs font-semibold text-violet-700 ring-1 ring-violet-100">
          <span className="h-1.5 w-1.5 rounded-full bg-violet-500" />
          Công thức
        </span>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
          Công thức quản trị rủi ro
        </h2>
      </div>

      <div className="mt-6 space-y-3">
        {FORMULAS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.title} className="overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-50/50">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center gap-3 px-5 py-4 text-left"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
                  <i className={`${f.icon}`} />
                </span>
                <span className="flex-1 text-sm font-bold text-slate-800">{f.title}</span>
                <i className={`ri-arrow-down-s-line text-lg text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>
              {isOpen && (
                <div className="border-t border-slate-200/70 px-5 py-4">
                  <p className="font-mono text-sm font-semibold text-violet-700">{f.formula}</p>
                  <p className="mt-2 text-xs leading-relaxed text-slate-500">{f.desc}</p>

                  {f.symbols && f.symbols.length > 0 && (
                    <div className="mt-4 border-t border-slate-200/70 pt-3">
                      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Ký hiệu</p>
                      <div className="mt-2 flex flex-wrap gap-2">
                        {f.symbols.map((s) => (
                          <span
                            key={s.sym}
                            className="inline-flex items-center gap-1.5 rounded-lg bg-white px-2.5 py-1.5 text-[11px] ring-1 ring-slate-200/80"
                          >
                            <span className="font-mono font-semibold text-violet-600">{s.sym}</span>
                            <span className="text-slate-500">{s.meaning}</span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}